import { Box, Grid, Stack, Typography } from "@mui/material";
import { updateSvgFillColor } from "../../../../utils";

type OfferProps = {
  offerContent?: any;
};

function T2_Offers(props: OfferProps) {
  const { offerContent } = props;

  return (
    <Stack
      sx={{
        p: "10px",
        borderRadius: "20px",
        background: "var(--white)",
        border: "2.5px solid var(--primary_brand_color_light)",
        width: "80%",
        mx: "auto",
        mt: { xs: "30px", md: "0px" },
        mb: { xs: "30px", md: "0px" },
        position: { md: "absolute" },
        left: { md: "50%" },
        transform: { md: "translate(-50%, -50%)" },
      }}
    >
      <Grid container spacing={0} sx={{ alignItems: "center" }}>
        {offerContent?.offers.map((data: any, index: number) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Typography
              component={"div"}
              sx={{
                p: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "left", md: "center" },
                gap: { xs: "10px", md: "15px" },
              }}
            >
              <Box
                component="div"
                sx={{
                  marginRight: "5px",
                  minWidth: "35px",
                  "& svg": {
                    width: "35px",
                    height: "30px",
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: updateSvgFillColor(
                    data?.svgCode,
                    "var(--primary_color)"
                  ),
                }}
              />
              <Typography
                component={"span"}
                sx={{
                  fontFamily: "var(--font_family_Medium)",
                  fontWeight: "var(--font_weight_1) !important",
                  color: "var(--text_color)",
                  fontSize: "14px",
                  lineHeight: "28px",
                }}
              >
                {data.item}
              </Typography>
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}

export default T2_Offers;
